import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-set-clear-class"
export default class extends Controller {
  static targets = ["ignoreMe", "checkbox"]
  static classes = ["ignored"]

  connect() {
    this.changeCheck()
  }

  changeCheck(event) {
    if (this.checkboxTarget.checked) {
      this.ignoreMeTarget.classList.add(this.ignoredClass)
    } else {
      this.ignoreMeTarget.classList.remove(this.ignoredClass)
    }
  }
}
